
import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState, useSelector } from "react";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import jwt_decode from 'jwt-decode';
import { setUserFromAuth0 } from 'redux/actions/UserActions';
import { CircularProgress } from '@material-ui/core';
import Home from 'pages/home/Home';
import { appConfig } from 'App';
// import { socket } from 'socket';



const Auth0Home = (props) => {
    let [appAuthenticated, setAppAuthenticated] = useState(false);

    const history = useHistory();
    const location = useLocation();
    const pathName = location.pathname;
    const { user, isAuthenticated, isLoading, getAccessTokenSilently, getIdTokenClaims, logout, loginWithRedirect } = useAuth0();

    // RENEW TOKEN INTERCEPTOR
    useEffect(()=>{
      let isRefreshing = false;
      let refreshPromise = null;

      let interceptor1 = axios.interceptors.request.use(async (config) => {
        if(isAuthenticated && appAuthenticated && !isLoading){
          let tokenClaims = await getIdTokenClaims();
          if (tokenClaims.exp * 1000 < Date.now() || (isRefreshing && config.url != "/tokenlogin")){
            if (!isRefreshing) {
              isRefreshing = true;
              refreshPromise = new Promise(async (resolve, reject) => {
                try {
                  let accessToken = await getAccessTokenSilently({
                    authorizationParams: {
                      audience: appConfig.AUTH0_AUDIENCE
                    }
                  });
                  let newTokenClaims = await getIdTokenClaims();
                  let tokens = await continueAppLogin(newTokenClaims, accessToken);
                  resolve(tokens);
                }
                catch (error) {
                  console.error('Error refreshing token:', error);
                  // Handle token refresh error here, logout user
                  logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
                  reject(error);
                }
                finally {
                  isRefreshing = false;
                  refreshPromise = null;
                }
              })
            }
            return refreshPromise.then((tokens) => {
              config.headers.common.Authorization = tokens.bearerIdToken;
              config.headers.common.AccessToken = tokens.accessToken;
              return config;
            })
            .catch((e)=>{
              console.log("refreshPromise resolve error", e);
              logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
            })
          }
        }
        return config;
      }, (error) => {
        console.error('Interceptors request error', error);
        logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
      });
      return () => {
        axios.interceptors.request.eject(interceptor1)
      };
    }, [appAuthenticated])

    const continueAppLogin = (tokenClaims, accessToken)=>{
      return new Promise(async (resolve, reject)=>{
        const idToken = tokenClaims.__raw;
        let bearerIdToken = `Bearer ${idToken}`;
        try{
          if (tokenClaims.exp * 1000 < Date.now()){
            throw new Error("Id Token expired");
          }
          let res = await axios.post("/tokenlogin", { token: bearerIdToken, email: user.email, accessToken: accessToken });
          let userData = res.data.user;
          // localStorage.setItem("UserLoggedIn", JSON.stringify(userData));
          // localStorage.setItem("auth0IdToken", bearerIdToken);
          setUserFromAuth0(
            true, 
            userData, 
            {
                bearerIdToken: bearerIdToken, 
                accessToken: accessToken
            },
            history, 
            pathName
          );
          setAppAuthenticated(true);
          // ====
          // socket.io.uri = appConfig.CENTRAL_API; // Set the server URL
          // socket.auth = { idToken: idToken };
          // socket.connect();    // Manually connect
          // ====
          resolve({
            bearerIdToken: bearerIdToken, 
            accessToken: accessToken
          });
        }
        catch(e){
          console.error(e);
          logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
          resolve(null);
        }
      })
    }
    
    useEffect(() => {
      (async () => {
        if(isAuthenticated){
          let decodedToken = null;
          let accessToken = null;
          try{
            accessToken = await getAccessTokenSilently({
              authorizationParams: {
                audience: appConfig.AUTH0_AUDIENCE
              }
            });
            decodedToken = jwt_decode(accessToken);
          }
          catch(e){
            console.error(e, e.error);
            logout({ logoutParams: { returnTo: window.location.origin, federated: true } });
            return ;
          }
          const tokenClaims = await getIdTokenClaims();
          if (tokenClaims.exp * 1000 < Date.now() || (appConfig.AUTH0_ORG_ID && decodedToken && !decodedToken.org_id) || (appConfig.AUTH0_ORG_ID && decodedToken && decodedToken.org_id && decodedToken.org_id != appConfig.AUTH0_ORG_ID)) {
            return loginWithRedirect({
              appState: { returnTo: window.location.origin },
              authorizationParams: {
                audience: appConfig.AUTH0_AUDIENCE, 
                organization: appConfig.AUTH0_ORG_ID
              }
            })
          }
          await continueAppLogin(tokenClaims, accessToken);
        }
      })();
    }, [isAuthenticated, isLoading]);
    
    if (isLoading) {
      return (<div className="loader"><CircularProgress  /></div>);
    }
  
    return (
      <>
        <> 
          {(isAuthenticated && !appAuthenticated) && (<div className="loader"><CircularProgress  /></div>)}
        </>
        <>
          {(isAuthenticated && appAuthenticated) && (<Home />)}
        </>
      </>
    );
};

export default Auth0Home;